import { red } from '@mui/material/colors';
import { createTheme } from '@mui/material/styles';

const paletteTheme = createTheme({
  palette: {
    primary: {
      light: '#BCE9E4',
      main: '#405E6F',
      dark: '#2D4654',
      '100': '#F3FAF9',
    },
    secondary: {
      light: '#DACCCC',
      main: '#917F7F',
      dark: '#675F5F',
      '100': '#ECECEC',
    },
    error: {
      main: red.A400,
    },
    common: {
      white: '#fff',
      black: '#000',
    },
  },
  shape: {
    borderRadius: 5,
  },
});

const theme = createTheme(paletteTheme, {
  components: {
    MuiTypography: {
      defaultProps: {
        color: paletteTheme.palette.primary.dark,
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '&.Mui-disabled .MuiOutlinedInput-notchedOutline': {
            borderColor: paletteTheme.palette.primary.dark,
            opacity: 0.1,
          },
        },
        input: {
          // Text color when disabled
          '&.Mui-disabled': {
            WebkitTextFillColor: paletteTheme.palette.primary.dark,
            opacity: 0.7,
          },
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          scrollbarColor: `${paletteTheme.palette.primary.main} ${paletteTheme.palette.primary.light}`,
          '&::-webkit-scrollbar, & *::-webkit-scrollbar': {
            backgroundColor: 'transparent',
            width: 10,
          },
          '&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb': {
            borderRadius: 5,
            backgroundColor: paletteTheme.palette.primary.main,
            minHeight: 10,
          },
          '&::-webkit-scrollbar-thumb:focus, & *::-webkit-scrollbar-thumb:focus': {
            backgroundColor: paletteTheme.palette.primary.main,
          },
          '&::-webkit-scrollbar-thumb:active, & *::-webkit-scrollbar-thumb:active': {
            backgroundColor: paletteTheme.palette.primary.main,
          },
          '&::-webkit-scrollbar-thumb:hover, & *::-webkit-scrollbar-thumb:hover': {
            backgroundColor: paletteTheme.palette.primary.main,
          },
        },
      },
    },
  },
});

export default theme;
